var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDottedImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 2,
    viewBox: "0 0 59 2",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500004 0.5C0.223862 0.5 3.8147e-06 0.723858 3.8147e-06 1C3.8147e-06 1.27614 0.223862 1.5 0.500004 1.5V0.5ZM58.5 0.5L57.4643 0.5V1.5H58.5V0.5ZM55.3929 0.5L53.3214 0.5V1.5L55.3929 1.5V0.5ZM51.25 0.5L49.1786 0.5V1.5L51.25 1.5V0.5ZM47.1071 0.5L45.0357 0.5V1.5L47.1071 1.5V0.5ZM42.9643 0.5L40.8929 0.5V1.5L42.9643 1.5V0.5ZM38.8214 0.5L36.75 0.5V1.5L38.8214 1.5V0.5ZM34.6786 0.5L32.6071 0.5V1.5L34.6786 1.5V0.5ZM30.5357 0.5L28.4643 0.5V1.5H30.5357V0.5ZM26.3929 0.5L24.3214 0.5V1.5L26.3929 1.5V0.5ZM22.25 0.5L20.1786 0.5V1.5L22.25 1.5V0.5ZM18.1071 0.5L16.0357 0.5V1.5L18.1071 1.5V0.5ZM13.9643 0.5L11.8928 0.5V1.5L13.9643 1.5V0.5ZM9.82142 0.5L7.74999 0.5V1.5L9.82142 1.5V0.5ZM5.67856 0.5L3.60713 0.5V1.5L5.67856 1.5V0.5ZM1.53569 0.5L0.500004 0.5V1.5H1.53569V0.5Z",
    fill: "#EAE6ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedImage);
export default __webpack_public_path__ + "static/media/dotted-image.d42b539274d9430aacf07310be35ddfe.svg";
export { ForwardRef as ReactComponent };